import { Link } from "react-router-dom";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import GrantFinder from "@/components/GrantFinder";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { useEffect } from "react";
import { useSiteContent } from "@/hooks/useSiteContent";
import { getBlock } from "@/lib/siteContent";

const Opportunities = () => {
  const { blocks: copy } = useSiteContent("opportunities");
  const heroHeadline = getBlock(copy, "hero_headline", "Capital that moves Alabama forward");
  const pageIntro = getBlock(
    copy,
    "page_intro",
    "A live, AI-curated feed of grants and funding programs aligned to our five focus areas. Save what fits, mark what you've applied to, and track everything from your profile.",
  );
  const { user } = useAuth();

  useEffect(() => {
    document.title = "Funding Opportunities | emrkt.co";
    const desc = "Live, AI-powered search of grants and funding for Alabama small and minority-led organizations.";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", desc);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main className="pt-24 pb-16">
        <section className="container mx-auto px-6 max-w-5xl text-center mb-10">
          <p className="text-xs uppercase tracking-[0.2em] text-primary mb-3">Funding Opportunities</p>
          <h1 className="font-display text-4xl md:text-5xl font-bold text-foreground mb-4">
            {heroHeadline}
          </h1>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            {pageIntro}
          </p>
          <div className="mt-6 flex items-center justify-center gap-3">
            {user ? (
              <Link to="/profile?tab=saved">
                <Button variant="outline" size="sm">View saved opportunities</Button>
              </Link>
            ) : (
              <Link to="/auth">
                <Button variant="outline" size="sm">Sign in to save</Button>
              </Link>
            )}
            <Link to="/coach">
              <Button size="sm" className="bg-primary text-primary-foreground hover:bg-primary/90">
                Get a readiness assessment
              </Button>
            </Link>
          </div>
        </section>
        <GrantFinder />
      </main>
      <SiteFooter />
    </div>
  );
};

export default Opportunities;